import { SIZE } from 'types/utils';

export const SIZE_TO_CLASS = {
  [SIZE.SM]: 'text-base',
  [SIZE.MD]: 'text-2xl',
  [SIZE.LG]: 'text-5xl',
};
